import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aeb9ea68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contianer" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "timerBtn"
}

import { ref } from 'vue'
import { Close } from '@element-plus/icons-vue'
import axios from 'axios'
import { t } from '@/plugins/i18n'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  props: [
  'title',
  'onagree',
  'ondisAgree',
  'fileUrl',
  'disableBtn',
  'timer'
],
  setup(__props, { expose }) {

const props = __props
const fetchText = (url: string) => axios.get(url)



const visable = ref(false)
const loading = ref(false)
const content = ref('')
const count = ref(5)
const confirmDisable = ref(true)
const nodeTimer = ref<number>()
const fetchTerm = async () => {
  try {
    const text = await fetchText(props.fileUrl)
    content.value = text.data.replace(/target=""/g, 'target="_blank"')
  } catch (error) {
    // ElMessage.error(t('获取条款内容失败'))
  } finally {
    loading.value = false
  }
}
const open = () => {
  visable.value = true

  clearInterval(nodeTimer.value)
  nodeTimer.value = 5
  confirmDisable.value = true
  fetchTerm()

  if (props.timer) {
    nodeTimer.value = setInterval(() => {
      count.value--
      if (count.value === 0) {
        confirmDisable.value = false
        clearInterval(nodeTimer.value)
      }
    }, 1000) as unknown as number
  }
}
const close = () => {
  visable.value = false

  count.value = 5
  clearInterval(nodeTimer.value)
  nodeTimer.value = undefined
  confirmDisable.value = true
}
const agree = () => {
  props.onagree && props.onagree()
  visable.value = false
}
const agreeFalse = () => {
  props.ondisAgree && props.ondisAgree()
  visable.value = false
}

expose({
  open,
  close,
  fetchText
})

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "destroy-on-close": "",
    modelValue: visable.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((visable).value = $event)),
    "show-close": false,
    width: "76%",
    onClose: close,
    "close-on-click-modal": false,
    "custom-class": "termModal-center"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(__props.title) + " ", 1),
          _createElementVNode("div", {
            class: "close",
            onClick: close
          }, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Close))
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", {
          class: "content",
          innerHTML: content.value
        }, null, 8, _hoisted_3),
        (__props.timer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_el_button, {
                type: "primary",
                disabled: confirmDisable.value,
                class: "confirmBtn",
                onClick: __props.ondisAgree
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('我确认并同意以上内容')) + " ", 1),
                  _withDirectives(_createElementVNode("span", null, "（" + _toDisplayString(count.value + 's') + "）", 513), [
                    [_vShow, confirmDisable.value]
                  ])
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]))
          : _withDirectives((_openBlock(), _createBlock(_component_el_space, {
              key: 1,
              class: "footer"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  round: "",
                  color: "#FA541C",
                  class: "btn1",
                  onClick: agree
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('同意')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  round: "",
                  class: "btn2",
                  onClick: agreeFalse
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('不同意')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512)), [
              [_vShow, !__props.disableBtn]
            ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})